import { useEffect } from 'react';
import { Box, Flex, SystemStyleObject } from '@chakra-ui/react';

import { StepRendererComponent, StepRendererProps } from '~/core/shared/types';
import { childrenExceptTypeEdge } from '~/core/shared/utils/styles';
import { BlocksRenderer } from './BlocksRenderer/BlocksRenderer';
import { useLayoutWrap } from './contexts/layoutWrap';
import { DefaultStepFooter } from './DefaultStepFooter.component';

const cssStyles: Record<string, SystemStyleObject> = {
  [childrenExceptTypeEdge('first')]: {
    mt: 6,
  },
};

export const DefaultStepRenderer: StepRendererComponent = ({
  blocks,
  isProcessing,
  onSubmit,
  step,
  workflowDataResolverDependencies,
}: StepRendererProps) => {
  const { setPageWidth } = useLayoutWrap();

  useEffect(() => {
    setPageWidth(step?.layoutWidth || 'md');
  }, [step]);

  return (
    <Flex as="form" direction="column" flex={1} onSubmit={onSubmit}>
      <Box css={cssStyles}>
        <BlocksRenderer
          blocks={blocks}
          workflowDataResolverDependencies={workflowDataResolverDependencies}
        />
      </Box>
      <DefaultStepFooter isProcessing={isProcessing} step={step} />
    </Flex>
  );
};
